import React from 'react'
import closeIcon from '../../../images/close-icon.png'
import pdfIcon from '../../../images/pdf-icon.svg'
import xmlIcon from '../../../images/xml-icon.svg'

import './selected-document.style.scss'

export const SelectedDocument = ({currentFile, setCurrentFile}) => {
  const icon = currentFile.mimetype.toLowerCase() === 'pdf' ? pdfIcon : xmlIcon;  
  const handleOnClick = (e) => {
    setCurrentFile(null)
    e.preventDefault()
  }
  return (
    <div className="selected-document">
      <img className="selected-document-icon" src={icon} alt=""/>
      <div className="selected-document-wrap">
        <p className="selected-document-title">Naziv dokumenta</p>
        <p className="selected-document-name">{currentFile.name}</p>
      </div>
      
      <img className="selected-document-close-icon" src={closeIcon} onClick={handleOnClick}  alt="close" />
    </div>
  )
}